import styled, { css } from 'styled-components';
import { Checkbox } from '../Checkbox/Checkbox';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;

  label {
    position: unset !important;
  }

  > label {
    margin-bottom: 5px;
  }
`;

type OptionsProps = {
  orientation: 'column' | 'row';
};

export const Options = styled.div<OptionsProps>`
  display: flex;
  width: 100%;
  flex-direction: ${({ orientation }) => orientation};
  gap: 5px;
  ${({ orientation }) =>
    orientation === 'row' &&
    css`
      gap: 16px;
      flex-wrap: wrap;
    `}
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
